// extracted by mini-css-extract-plugin
export default {"input":"Yba-z","button":"Zba-z","selected":"_ba-z","unavailable":"aca-z","oos":"bca-z","image":"cca-z","paperCutDisabledOverlay":"dca-z"};